import React from "react";
import Typography from "@mui/material/Typography";
import tokens from "@/theme/tokens";

/**
 * Replaces the global `.inline-error` from _theme.scss, which was two
 * declarations — the error red and a 0.9em step down. Both are theme values,
 * so the `@ts-ignore` on the untyped props goes with the class name.
 */
export const ErrorComponent = ({
  children,
}: {
  children?: React.ReactNode;
}) => (
  <Typography component="span" sx={{ color: "error.main", fontSize: tokens.fontSize.authErrorMessage }}>
    {children}
  </Typography>
);
